export function SetErrorMsg(errCode) {
    let err_msg = "";

    switch(errCode) {
        case 1:
            err_msg = "Úgy tűnik ehhez az email címhez már tartozik fiók! Használd a Google/Facebook bejelentkezést, vagy bejelentkezés menün belül a jelszó emlékeztetőt új jelszó beállításához!";
            break;
        case 2:
            err_msg = "A megadott e-mail cím aktiválása folyamatban van, az e-mail újraküldéséhez kattints a linkre.";
            break;
        case 3:
            err_msg = "A felhasználó elérte a regisztrációs e-mail küldési limitet"
            break;
        default:
            err_msg = "";
    }

    return err_msg;
}